// extracted by mini-css-extract-plugin
export default {"comment":"comment_Jb5sP","reply":"reply_HALKo"};